<header class="header row no-gutters">
  <div class="hd-left col-sm-8 no-padding">
        <div class="user-info__data">
            <div class="roteiro-seletor" title='Código do Roteiro'><span>ROTEIRO</span> {{ boxListTruckService.roteiroSelecionado }}</div>
            <div class="user-info__nome ng-binding">
                <span class='veiculo' title='Veículo'>{{ mainHeaderTruckService.veiculo }} </span>| <span class='motorista' title='Motorista'>{{ mainHeaderTruckService.nomeMotorista }}</span></div>            
            <a ng-href="#here" ng-click="dadosBateria(null)" href="#here">
                <div class="user-info__bateria in-blk ng-binding">
                    <i class="fa  fa-battery-half"></i>100%
                </div>
            </a>
            <div *ngIf="dataUltimaInformacao" class="user-info__sync in-blk ng-binding" title='Última Atualização'>
                <i class="fa fa-clock-o"></i>{{ dataUltimaInformacao | date: 'dd/MM/yyyy HH:mm' }}
            </div>
        </div>
    </div>
    <div class="hd-right col-sm-4 text-right">
        
        <ng-content></ng-content>
    </div>
</header>